import { createContext } from 'react';
import { PenaltyRecord, MemberPenalty } from '@/types/penalty';

export interface PenaltyStats {
  totalPenalties: number;
  activePenalties: number;
  totalDots: number;
  penaltiesByType: {
    late_cancel: number;
    no_show: number;
  };
}

export interface PenaltyContextType {
  penalties: MemberPenalty[];
  addPenalty: (penalty: Omit<PenaltyRecord, 'id' | 'timestamp'>) => void;
  getMemberPenalty: (memberId: string) => MemberPenalty | null;
  clearExpiredPenalties: () => void;
  removePenalty: (memberId: string, recordId: string) => void;
  getPenaltyStats: () => PenaltyStats;
}

export const PenaltyContext = createContext<PenaltyContextType | undefined>(undefined);
